export class staticport{
            static porturl ='http://localhost:8080/CosmoSports';
}